import React from 'react'

const SetUpTeam = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='48'
      height='48'
      fill='none'
      viewBox='0 0 48 48'
    >
      <path
        stroke='#A1A1AA'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M18 36v-5.17c0-3.799 2.735-6.964 6.224-6.964 3.395 0 6.224 3.06 6.224 6.964V36M5 36v-2.983C5 30.827 6.758 29 9 29c2.182 0 4 1.765 4 4.017V36M35 36v-2.983C35 30.827 36.758 29 39 29c2.182 0 4 1.765 4 4.017V36'
      />
      <circle cx='9' cy='22' r='4' stroke='#A1A1AA' strokeWidth='2' />
      <circle cx='39' cy='22' r='4' stroke='#A1A1AA' strokeWidth='2' />
      <circle cx='24' cy='16' r='5' stroke='#A1A1AA' strokeWidth='2' />
    </svg>
  )
}
const ManageCategories = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='48'
      height='48'
      fill='none'
      viewBox='0 0 48 48'
    >
      <rect
        width='5.98'
        height='5.972'
        x='5'
        y='5'
        stroke='#A1A1AA'
        strokeWidth='2'
        rx='1'
      />
      <path
        stroke='#A1A1AA'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M28.938 16.581h9.06M28.938 27.388h9.06M28.938 38.542h9.06M28.938 19.831h9.06M28.938 30.638h9.06M28.938 41.793h9.06M41.377 16.581H43M41.377 27.388H43M41.377 38.542H43M41.377 19.831H43M41.377 30.638H43M41.377 41.793H43'
      />
      <rect
        width='5.98'
        height='5.972'
        x='16.471'
        y='15.036'
        stroke='#A1A1AA'
        strokeWidth='2'
        rx='1'
      />
      <rect
        width='5.98'
        height='5.972'
        x='16.471'
        y='26.066'
        stroke='#A1A1AA'
        strokeWidth='2'
        rx='1'
      />
      <rect
        width='5.98'
        height='5.972'
        x='16.471'
        y='37.028'
        stroke='#A1A1AA'
        strokeWidth='2'
        rx='1'
      />
      <path
        stroke='#A1A1AA'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M8.084 11.176v6.955h7.793'
      />
      <path
        stroke='#A1A1AA'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M8.084 17.515v11.498h7.793'
      />
      <path
        stroke='#A1A1AA'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M8.084 28.841v11.498h7.793'
      />
    </svg>
  )
}
const CreateExpensePolicies = () => {
  return (
    <svg width='48' height='48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20.9435 39.8546H5V5.00818H32.9012V25.9079'
        stroke='#A1A1AA'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.98633 13.5806H19.5489M8.98633 23.4235H19.5489M8.98633 18.3225H19.5489M27.3216 16.4267L23.9336 12.9943M23.9336 16.4267L27.3216 12.9943'
        stroke='#A1A1AA'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
      />
      <path
        d='M28.0191 21.5053L25.3286 24.5338L24.0332 23.5243'
        stroke='#A1A1AA'
        strokeWidth='2'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        stroke='#A1A1AA'
        strokeWidth='2'
        strokeLinejoin='round'
        d='M24.9297 29.8903H43.000299999999996V43.0082H24.9297z'
      />
      <path
        d='M24.9297 33.8727L42.8661 33.8727M38.1895 37.0658L39.5939 37.0658'
        stroke='#A1A1AA'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
const SetExpenseApprovals = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='48'
      height='48'
      fill='none'
      viewBox='0 0 48 48'
    >
      <path
        stroke='#A1A1AA'
        strokeLinecap='round'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M10 25.09h17.3M10 29h9'
      />
      <path
        stroke='#A1A1AA'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M25.134 9.693l-8.753 9.726-4.215-3.242'
      />
      <path
        stroke='#A1A1AA'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M20.944 39.855H5V5.008h27.901v20.9'
      />
      <path
        stroke='#A1A1AA'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M24.93 29.89H43.001000000000005V43.008H24.93z'
      />
      <path
        stroke='#A1A1AA'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M24.93 33.873h17.936M38.19 37.066h1.404'
      />
    </svg>
  )
}
const ContactProductSpecialist = () => {
  return (
    <svg width='48' height='48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.51399 17.9165L9.51356 17.9166L7.63465 18.4833C7.63461 18.4833 7.63457 18.4833 7.63453 18.4833C7.13664 18.6336 6.68255 18.9017 6.30889 19.2659C5.93562 19.6297 5.65518 20.0782 5.49139 20.5737L5.49138 20.5737C4.34322 24.0462 5.18124 28.4355 8.30607 33.8558M9.51399 17.9165L10.9623 27.3373C10.7964 27.6772 10.7844 28.0392 10.8074 28.3204C10.8319 28.6192 10.906 28.9397 11.0112 29.2683C11.222 29.9271 11.5939 30.7283 12.1232 31.6469L12.1234 31.6472C12.7187 32.6794 13.2744 33.4507 13.7699 33.9627C14.0154 34.2164 14.2789 34.4409 14.5569 34.5946C14.8122 34.7357 15.2392 34.9036 15.7178 34.7624L15.7178 34.7624L15.7277 34.7594L18.4087 33.9378C18.9432 33.7744 19.5154 33.7825 20.0451 33.9611C20.5748 34.1397 21.0356 34.4798 21.3629 34.9341L21.3632 34.9345L23.0249 37.2388C23.405 37.7659 23.5811 38.4135 23.5204 39.0611C23.4597 39.7086 23.1665 40.3118 22.6955 40.7587C22.6954 40.7588 22.6953 40.7588 22.6952 40.7589C22.6952 40.759 22.6951 40.759 22.695 40.7591L21.2658 42.1132L21.2654 42.1135C20.8853 42.4741 20.4239 42.737 19.9205 42.8802C19.4171 43.0233 18.8867 43.0423 18.3744 42.9357C14.8019 42.1911 11.4298 39.2729 8.30607 33.8558M9.51399 17.9165C10.1366 17.7284 10.8062 17.7736 11.398 18.0437C11.9898 18.3138 12.4636 18.7905 12.7305 19.3851L12.7305 19.3851M9.51399 17.9165L12.7305 19.3851M8.30607 33.8558L7.43972 34.3553L8.30607 33.8558ZM12.7305 19.3851L13.8998 21.9898L13.8999 21.9899M12.7305 19.3851L13.8999 21.9899M13.8999 21.9899C14.1295 22.5012 14.1935 23.0718 14.0828 23.6215C13.9721 24.1712 13.6923 24.6722 13.283 25.0543L13.283 25.0544M13.8999 21.9899L13.283 25.0544M13.283 25.0544L11.2398 26.962L11.2392 26.9625M13.283 25.0544L11.2392 26.9625M11.2392 26.9625C11.125 27.0693 11.0314 27.196 10.9628 27.3364L11.2392 26.9625Z'
        stroke='#EB5C24'
        strokeWidth='2'
      />
      <mask id='a' fill='#fff'>
        <path d='M22.8438 4.19128C22.0171 4.19128 21.2242 4.51971 20.6396 5.10431C20.055 5.68891 19.7266 6.4818 19.7266 7.30856V27.2482C19.7266 27.4024 19.7724 27.5531 19.8581 27.6813C19.9438 27.8095 20.0657 27.9093 20.2082 27.9682C20.3507 28.0271 20.5075 28.0424 20.6587 28.0122C20.8099 27.982 20.9487 27.9076 21.0576 27.7984L25.5044 23.3516C25.7967 23.0593 26.193 22.895 26.6064 22.8949H41.5475C42.3742 22.8949 43.1671 22.5665 43.7517 21.9819C44.3363 21.3973 44.6647 20.6044 44.6647 19.7776V7.30856C44.6647 6.4818 44.3363 5.68891 43.7517 5.10431C43.1671 4.51971 42.3742 4.19128 41.5475 4.19128H22.8438Z' />
      </mask>
      <path
        d='M22.8438 4.19128V2.19128V4.19128ZM19.7266 7.30856H17.7266H19.7266ZM19.7266 27.2482H17.7266V27.2486L19.7266 27.2482ZM21.0576 27.7984L19.6434 26.3842L19.6416 26.386L21.0576 27.7984ZM25.5044 23.3516L26.9186 24.7658L26.9189 24.7656L25.5044 23.3516ZM26.6064 22.8949V20.8949L26.606 20.8949L26.6064 22.8949ZM22.8438 2.19128C21.4866 2.19128 20.1851 2.73042 19.2254 3.6901L22.0538 6.51853C22.2633 6.309 22.5475 6.19128 22.8438 6.19128V2.19128ZM19.2254 3.6901C18.2657 4.64977 17.7266 5.95137 17.7266 7.30856H21.7266C21.7266 7.01224 21.8443 6.72805 22.0538 6.51853L19.2254 3.6901ZM17.7266 7.30856V27.2482H21.7266V7.30856H17.7266ZM17.7266 27.2486C17.7267 27.7986 17.8899 28.3361 18.1957 28.7932L21.5205 26.5694C21.6548 26.7701 21.7265 27.0062 21.7266 27.2478L17.7266 27.2486ZM18.1957 28.7932C18.5014 29.2503 18.9359 29.6065 19.4442 29.8166L20.9722 26.1199C21.1954 26.2122 21.3862 26.3686 21.5205 26.5694L18.1957 28.7932ZM19.4442 29.8166C19.9524 30.0266 20.5115 30.0812 21.0508 29.9734L20.2665 26.051C20.5034 26.0037 20.749 26.0276 20.9722 26.1199L19.4442 29.8166ZM21.0508 29.9734C21.5901 29.8656 22.0853 29.6002 22.4736 29.2108L19.6416 26.386C19.8122 26.215 20.0297 26.0984 20.2665 26.051L21.0508 29.9734ZM22.4719 29.2126L26.9186 24.7658L24.0902 21.9374L19.6434 26.3842L22.4719 29.2126ZM26.9189 24.7656C26.8361 24.8484 26.7239 24.8949 26.6068 24.8949L26.606 20.8949C25.6622 20.8951 24.7572 21.2702 24.09 21.9376L26.9189 24.7656ZM26.6064 24.8949H41.5475V20.8949H26.6064V24.8949ZM41.5475 24.8949C42.9047 24.8949 44.2063 24.3558 45.1659 23.3961L42.3375 20.5677C42.128 20.7772 41.8438 20.8949 41.5475 20.8949V24.8949ZM45.1659 23.3961C46.1256 22.4364 46.6647 21.1348 46.6647 19.7776H42.6647C42.6647 20.074 42.547 20.3581 42.3375 20.5677L45.1659 23.3961ZM46.6647 19.7776V7.30856H42.6647V19.7776H46.6647ZM46.6647 7.30856C46.6647 5.95137 46.1256 4.64977 45.1659 3.6901L42.3375 6.51853C42.547 6.72806 42.6647 7.01224 42.6647 7.30856H46.6647ZM45.1659 3.6901C44.2063 2.73042 42.9047 2.19128 41.5475 2.19128V6.19128C41.8438 6.19128 42.128 6.309 42.3375 6.51853L45.1659 3.6901ZM41.5475 2.19128H22.8438V6.19128H41.5475V2.19128Z'
        fill='#EB5C24'
        mask='url(#a)'
      />
      <circle cx='26.6836' cy='14.2241' r='1.5' fill='#EB5C24' />
      <circle cx='32.1953' cy='14.2241' r='1.5' fill='#EB5C24' />
      <circle cx='37.707' cy='14.2241' r='1.5' fill='#EB5C24' />
    </svg>
  )
}
const CreateExpenseReport = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='48'
      height='48'
      fill='none'
      viewBox='0 0 48 48'
    >
      <path
        stroke='#A1A1AA'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeMiterlimit='10'
        strokeWidth='2'
        d='M20.944 39.846H5V5h27.901v20.9'
      />
      <path
        stroke='#A1A1AA'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M24.93 29.882H43.001000000000005V43H24.93z'
      />
      <path
        stroke='#A1A1AA'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2'
        d='M24.93 33.864h17.936M38.19 37.058h1.404'
      />
      <path fill='#A1A1AA' d='M13 22.822H14.988V25.865H13z' />
      <path fill='#A1A1AA' d='M16.227 20.548H18.215V25.865H16.227z' />
      <path
        fill='#A1A1AA'
        d='M19.674 17.183H21.662V25.865000000000002H19.674z'
      />
      <path fill='#A1A1AA' d='M23.123 15H25.111V25.865000000000002H23.123z' />
    </svg>
  )
}

const AddMoneyToYourWallet = () => (
  <svg
    width='40'
    height='32'
    viewBox='0 0 40 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M39 6.92664H1V30.0001C1 30.5524 1.44772 31.0001 2 31.0001H39V6.92664Z'
      stroke='#A1A1AA'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M38.0492 23.4345H25.1714C22.8492 23.4345 20.9492 21.5629 20.9492 19.2755C20.9492 16.988 22.8492 15.1165 25.1714 15.1165H38.0492C38.577 15.1165 38.8937 15.5324 38.8937 15.9483V22.6027C38.9992 23.0186 38.577 23.4345 38.0492 23.4345Z'
      stroke='#A1A1AA'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
    <path
      d='M25.5874 21.0431C26.5785 21.0431 27.3819 20.2517 27.3819 19.2755C27.3819 18.2993 26.5785 17.5079 25.5874 17.5079C24.5964 17.5079 23.793 18.2993 23.793 19.2755C23.793 20.2517 24.5964 21.0431 25.5874 21.0431Z'
      fill='#A1A1AA'
    />
    <path
      d='M1 6.92674V5.26313C1 2.87168 2.9 1.00012 5.32778 1.00012H29.3944C31.8222 1.00012 33.7222 2.87168 33.7222 5.26313V7.03071'
      stroke='#A1A1AA'
      strokeWidth='2'
      strokeMiterlimit='10'
      strokeLinejoin='round'
    />
  </svg>
)

const CreateNewTrip = () => {
  return (
    <svg
      width='41'
      height='41'
      viewBox='0 0 41 41'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M28.6236 1.51645C31.5862 1.67057 34.3868 2.91741 36.485 5.0165C38.4312 6.96412 39.6493 9.52212 39.9351 12.2618C40.2209 15.0015 39.5569 17.7562 38.0545 20.0642L38.8926 20.6098L38.0545 20.0642L29.0165 33.9484C28.9061 34.118 28.7553 34.2572 28.5777 34.3535C28.4001 34.4498 28.2014 34.5002 27.9994 34.5002C27.7975 34.5002 27.5988 34.4498 27.4212 34.3535C27.2436 34.2572 27.0928 34.118 26.9824 33.9485C26.9824 33.9485 26.9824 33.9485 26.9824 33.9484L17.9448 20.0643C16.3256 17.5763 15.6847 14.5762 16.1459 11.6431C16.6071 8.70994 18.1377 6.05188 20.442 4.18185C22.7463 2.31182 25.661 1.36233 28.6236 1.51645Z'
        stroke='#A1A1AA'
        strokeWidth='2'
      />
      <path
        d='M32.9563 13.412C32.9563 16.1142 30.7381 18.3237 27.9782 18.3237C25.2182 18.3237 23 16.1142 23 13.412C23 10.7098 25.2182 8.50024 27.9782 8.50024C30.7381 8.50024 32.9563 10.7098 32.9563 13.412Z'
        stroke='#A1A1AA'
        strokeWidth='2'
      />
      <rect
        x='1.94141'
        y='25.5564'
        width='18.1459'
        height='13.6094'
        stroke='#A1A1AA'
        strokeWidth='2'
        strokeLinejoin='round'
      />
      <path
        d='M7.04492 24.98V24.7058C7.04492 22.357 8.94903 20.4529 11.2979 20.4529V20.4529C13.6467 20.4529 15.5508 22.357 15.5508 24.7058V24.98'
        stroke='#A1A1AA'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <rect
        x='10.4482'
        y='29.7653'
        width='1.70117'
        height='2.83529'
        stroke='#A1A1AA'
        strokeWidth='1.70117'
      />
      <line
        x1='2.85547'
        y1='31.3611'
        x2='21.0013'
        y2='31.3611'
        stroke='#A1A1AA'
        strokeWidth='2'
      />
    </svg>
  )
}

const SetCompanySettings = () => {
  return (
    <svg
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M37.8694 25.8363L37.799 26.3988L38.2456 26.7481L42.4514 30.037C42.4512 30.0415 42.4501 30.0482 42.4461 30.0567L38.4559 36.9599L38.4558 36.9599L38.4557 36.9601C38.4508 36.9598 38.4442 36.9589 38.4354 36.9568L33.4943 34.9724L32.972 34.7626L32.5216 35.1003C31.5333 35.8416 30.487 36.4742 29.3624 36.935L28.833 37.152L28.7518 37.7184L27.9943 43.0003H20.0089L19.2515 37.7184L19.1703 37.152L18.6409 36.935C17.5093 36.4713 16.4661 35.8575 15.4913 35.1077L15.0388 34.7596L14.509 34.9724L9.54978 36.964L9.5474 36.9599L5.55712 30.0567C5.55318 30.0482 5.55202 30.0415 5.55183 30.037L9.75764 26.7481L10.2042 26.3988L10.1339 25.8363C10.0565 25.2168 10.0016 24.6023 10.0016 24.0003C10.0016 23.3984 10.0565 22.7839 10.1339 22.1644L10.2042 21.6018L9.75764 21.2526L5.54762 17.9604L9.5474 11.0408L9.54746 11.0408L9.54754 11.0407C9.55406 11.0412 9.56054 11.0421 9.56692 11.0435L14.509 13.0283L15.0313 13.2381L15.4816 12.9003C16.4699 12.1591 17.5163 11.5265 18.6409 11.0656L19.1703 10.8487L19.2515 10.2823L20.0089 5.00034H27.9943L28.7518 10.2823L28.833 10.8487L29.3624 11.0656C30.494 11.5294 31.5372 12.1431 32.5119 12.893L32.9645 13.2411L33.4943 13.0283L38.4535 11.0367L38.4559 11.0408L42.4461 17.944C42.4501 17.9525 42.4512 17.9592 42.4514 17.9637L38.2456 21.2526L37.799 21.6018L37.8694 22.1644C37.9469 22.7848 38.0016 23.379 38.0016 24.0003C38.0016 24.6217 37.9469 25.2158 37.8694 25.8363Z'
        stroke='#A1A1AA'
        strokeWidth='2'
      />
      <circle cx='24' cy='24.0002' r='7' stroke='#A1A1AA' strokeWidth='2' />
    </svg>
  )
}
const SetUpPaymentmethod = () => {
	return (
	  <svg
		xmlns='http://www.w3.org/2000/svg'
		width='48'
		height='48'
		viewBox='0 0 48 48'
		fill='none'
	  >
		<rect
		  x='6.45825'
		  y='16.4078'
		  width='39.0941'
		  height='24.878'
		  rx='6'
		  stroke='#A1A1AA'
		  strokeWidth='2'
		/>
		<path
		  fillRule='evenodd'
		  clipRule='evenodd'
		  d='M43.3772 13.565C43.8171 14.5561 44.0616 15.6533 44.0616 16.8075V25.6855C44.0616 30.1038 40.4798 33.6855 36.0616 33.6855H9.44765C7.10502 33.6855 4.99757 32.6786 3.53448 31.074C3.18943 30.1803 3.00024 29.209 3.00024 28.1936V19.7598C3.00024 15.3415 6.58197 11.7598 11.0002 11.7598H38.3147C40.2355 11.7598 41.9982 12.4367 43.3772 13.565Z'
		  fill='white'
		/>
		<rect
		  x='3.15845'
		  y='6'
		  width='39.0941'
		  height='24.878'
		  rx='6'
		  fill='white'
		  stroke='#A1A1AA'
		  strokeWidth='2'
		/>
		<rect x='3.00024' y='12' width='39' height='5' fill='#A1A1AA' />
		<rect
		  x='10.2349'
		  y='37.129'
		  width='10.4716'
		  height='0.951966'
		  rx='0.475983'
		  fill='#A1A1AA'
		/>
		<rect
		  x='10.2349'
		  y='34.2733'
		  width='27.607'
		  height='0.951966'
		  rx='0.475983'
		  fill='#A1A1AA'
		/>
		<rect
		  x='5.31616'
		  y='18.8828'
		  width='10.4716'
		  height='1.90393'
		  rx='0.951966'
		  fill='#A1A1AA'
		/>
	  </svg>
	)
  }

const ArrowRightAltIcon = () => (
  <svg aria-hidden="true" focusable="false" height="16px" data-prefix="fas" data-icon="arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path></svg>
)

export {
  SetUpTeam,
  ManageCategories,
  CreateExpensePolicies,
  SetExpenseApprovals,
  ContactProductSpecialist,
  CreateExpenseReport,
  AddMoneyToYourWallet,
  CreateNewTrip,
  SetCompanySettings,
  ArrowRightAltIcon,
  SetUpPaymentmethod
}
